import { Helmet } from 'react-helmet';
import React, { useState, useEffect, useRef } from 'react';
import uploadGraphic from './upload-graphic.png'; // Ensure the image is in your src folder
import api, { queryFiles, getProjectById, getConversations } from './../api';
import './DocFile.css'
import { useParams } from 'react-router-dom';

function FileOrUrlPopup({ onClose, onFileSelected, onUrlSubmitted }) {
  const [isUrlInputVisible, setIsUrlInputVisible] = useState(false);
  const [url, setUrl] = useState('');

  const handleFileChange = (e) => {
    onFileSelected(e.target.files[0]);
    onClose();
  };

  const handleUrlSubmit = () => {
    onUrlSubmitted(url);
    onClose();
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="popup-header">
          <h3>Input Method</h3>
          <button className="close-button" onClick={onClose}>X</button>
        </div>
        <div className="popup-body">
          {!isUrlInputVisible ? (
            <>
              <button onClick={() => document.getElementById('file-input-popup').click()} className="popup-button">Upload File</button>
              <input type="file" onChange={handleFileChange} id="file-input-popup" className="file-input" style={{ display: 'none' }} />
              <button onClick={() => setIsUrlInputVisible(true)} className="popup-button">Enter URL</button>
            </>
          ) : (
            <>
              <input type="text" value={url} onChange={(e) => setUrl(e.target.value)} placeholder="Enter URL" className="url-input" />
              <button onClick={handleUrlSubmit} className="popup-button">Submit URL</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function DocFile() {
  const title = 'DocFile';
  const [file, setFile] = useState(null);
  const [query, setQuery] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const chatEndRef = useRef(null);
  const [project, setProject] = useState(null);
  const [conversition, setConversation] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    fetchProjectDetails();
    fetchProjectConversations();
  }, [id]);

  const fetchProjectDetails = async () => {
    if (!id) return;
    try {
      const response = await getProjectById(id);
      setProject(response.data);
    } catch (error) {
      console.error('Error fetching project details:', error);
    }
  };
  const fetchProjectConversations = async () => {
    try {
      const response = await getConversations(id);
      console.log("history:", response.data);
      setConversation(response.data);
    } catch (error) {
      console.error('Error fetching project details:', error);
    }
  };

  const handleFileChange = (file) => {
    setFile(file);
  };

  const handleUrlSubmitted = async (url) => {
    console.log("URL submitted:", url);

    // Handle URL submission logic here
    try {
      await api.post("/upload-from-url", { url });
      alert('File uploaded from URL successfully');
    } catch (error) {
      console.error(error);
      alert('Error uploading file from URL');
    }
  };

  const handleFileUpload = async () => {
    const formData = new FormData();
    formData.append('file', file);
    try {
      await api.post('/upload_file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });
      alert('File uploaded successfully');
    } catch (error) {
      console.error(error);
      alert('Error uploading file');
    }
  };

  const handleQueryChange = (e) => {
    setQuery(e.target.value);
  };

  const handleQuerySubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await queryFiles(query, project?.id, project?.files);
      const queryResult = response.data.answer;

      if (queryResult) {
        const newChatHistory = [{
          question: query,
          answer: queryResult.answer_llm,
          sources: queryResult.sources
        }];
        setChatHistory([...chatHistory, ...newChatHistory]);
      } else {
        setChatHistory([...chatHistory, { question: query, answer: "No results found." }]);
      }
      setQuery(''); // Reset query input after submission
    } catch (error) {
      console.error('API error:', error.response ? error.response.data : error.message);
      alert('Error processing query: ' + (error.response ? error.response.data.error : error.message));
      setChatHistory([...chatHistory, { question: query, answer: "Error processing query." }]);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chatHistory]);

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const formatResult = (result) => {
    let stringResult = typeof result === 'string' ? result : JSON.stringify(result, null, 2);

    // Replace newline characters with HTML line breaks
    stringResult = stringResult.replace(/\n/g, '<br>');

    // Replace spaces at the beginning of lines with non-breaking spaces
    // This preserves indentation when displayed in HTML
    stringResult = stringResult.replace(/^ +/gm, (match) => {
      return '&nbsp;'.repeat(match.length);
    });

    return stringResult;
  };
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <div className="container-fluid">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <nav className="bg-body-tertiary border-bottom">
            <div className="container-fluid d-flex flex-wrap">
              <ul className="nav me-auto align-items-center">
                <li className="nav-item fs-5">
                  <a className="nav-link link-body-emphasis px-0" data-bs-toggle="collapse" role="button" data-bs-target="#patientList" aria-expanded="true" aria-controls="patientList">
                    <i className="bi bi-window-sidebar"></i>
                  </a>
                </li>
                <li className="nav-item fs-5">
                  <a className="nav-link link-body-emphasis px-2" href="#">
                    <i className="bi bi-plus-square-dotted"></i>
                  </a>
                </li>
                <li className="nav-item fs-6"><strong>Project:</strong>{project?.name} </li>
              </ul>
            </div>
          </nav>
        </div>
        <div className="App">
          <div className="container">
            <div className="left-section">
              <h1>Click Here to Upload Documents</h1>
              <div className="upload-section" onClick={togglePopup}>
                <img src={uploadGraphic} alt="Upload" className="upload-graphic" />
              </div>
              {file && (
                <button onClick={handleFileUpload} className="upload-button">Process</button>
              )}

            </div>
            <div className="right-section">
              <div className="chat-history">
                {chatHistory.map((entry, index) => (
                  <div key={index} className="chat-entry">
                    <div className="user-query">{entry.question}</div>
                    <div className="ai-response" dangerouslySetInnerHTML={{ __html: formatResult(entry.answer) }}></div>
                    <div className="ai-response">
                      <ui>
                        {entry.sources.map((s, i) => (
                          <li key={i} >
                            {s.filename}
                          </li>
                        ))}
                      </ui>
                    </div>
                  </div>
                ))}
                {/*    <div ref={chatEndRef} /> */}
              </div>
              <div className="chat-section">
                <textarea
                  value={query}
                  onChange={handleQueryChange}
                  placeholder="Ask a question..."
                  className="query-input"
                  rows={1}
                />
                <button onClick={handleQuerySubmit} className="chat-button" disabled={isLoading}>Enter</button>
              </div>
            </div>
          </div>
          {isPopupOpen && (
            <FileOrUrlPopup
              onClose={togglePopup}
              onFileSelected={handleFileChange}
              onUrlSubmitted={handleUrlSubmitted}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default DocFile;
